import type { AppLanguage } from '../../i18n/locale';

export function unpaidInvoiceTitle(publicCode: string, language: AppLanguage) {
  return language === 'en' ? `Unpaid invoice #${publicCode}` : `Не оплачен счёт #${publicCode}`;
}

export function payInvoiceByCardLabel(amount: string, language: AppLanguage) {
  return language === 'en' ? `Pay ${amount} by card` : `Оплатить ${amount} картой`;
}
